/**
 * Reusable Textarea UI Component
 */

import type { TextareaHTMLAttributes } from "react";

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  readonly errorMessage?: string;
  readonly resize?: boolean;
}

export const Textarea = ({
  errorMessage,
  className,
  id,
  disabled,
  resize = false,
  ...restProps
}: TextareaProps): React.JSX.Element => {
  const helperId = errorMessage ? `${id ?? "textarea"}-error` : undefined;

  const baseClasses = "w-full px-3 py-2 rounded-lg border text-sm leading-6 text-gray-900 bg-white transition-all duration-150 ease-in-out min-h-[80px] placeholder:text-gray-400 focus:outline-none";
  const normalClasses = "border-gray-200 focus:border-[#001a41] focus:shadow-[0_0_0_1px_rgba(0,26,65,0.08)]";
  const errorClasses = "border-red-600";
  const disabledClasses = "bg-gray-100 text-gray-500 cursor-not-allowed";
  const resizeClasses = resize ? "resize-y" : "resize-none";

  const classes = [
    baseClasses,
    errorMessage ? errorClasses : normalClasses,
    disabled ? disabledClasses : "",
    resizeClasses,
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="flex flex-col gap-1">
      <textarea
        id={id}
        className={classes}
        aria-invalid={errorMessage ? true : undefined}
        aria-describedby={helperId}
        disabled={disabled}

        {...restProps}
      />
      {errorMessage && (
        <p id={helperId} className="text-xs text-red-600">
          {errorMessage}
        </p>
      )}
    </div>
  );
};

